/* tslint:disable:only-arrow-functions prefer-for-of no-increment-decrement */
import { Maybe } from './types';

/**
 *
 * Init code provided by pendo. Slightly altered for integration with React.
 * https://support.pendo.io/hc/en-us/articles/360046272771-Developer-s-guide-to-installing-Pendo#the-install-script-snippet--0-4
 *
 */
export function attachPendo(apiKey: string): Maybe<HTMLScriptElement> {
  // eslint-disable-next-line func-names, @typescript-eslint/no-explicit-any
  return ((
    p: Record<string, any>,
    e,
    n,
    d
  ): Maybe<HTMLScriptElement> => {
    const v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    // eslint-disable-next-line no-multi-assign, no-param-reassign
    const o = (p[d] = p[d] || {});
    // eslint-disable-next-line no-underscore-dangle

    o._q = [];

    // eslint-disable-next-line func-names, no-underscore-dangle, prefer-rest-params, @typescript-eslint/explicit-function-return-type, no-plusplus
    for (let w = 0; w < v.length; ++w) {
      (function (m) {
        o[m] =
          o[m] ||
          function () {
            o._q[m === v[0] ? 'unshift' : 'push'](
              [m].concat([].slice.call(arguments, 0))
            );
          };
      })(v[w]);
    }

    const scriptEls: HTMLCollection = e.getElementsByTagName(n);
    const z = scriptEls.item(0);
    const zParent = z?.parentNode;

    let y: Maybe<HTMLScriptElement> = null;

    if (zParent) {
      y = e.createElement(n) as HTMLScriptElement;
      y.id = 'pendo-init';
      y.async = true;
      y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
      zParent.insertBefore(y, z);
    }

    return y;
  })(window, document, 'script', 'pendo');
}
